import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import colegioIcon from '../assets/images/colegio-icon.png';
import '../assets/styles/Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="navbar">
      {/* Versión desktop: contenedor único con fondo rojo */}
      <div className="navbar-container">
        <div className="logo-container">
          <Link to="/">
            <img src={colegioIcon} alt="Logo Colegio" className="colegioIcon" />
          </Link>
          <div className="header-text">
            <h1 className="header-title">Colegio Cristiano</h1>
            <h1 className="header-title">Le Beau Jour</h1>
          </div>
        </div>
        <div className="menu-container">
          <ul className="navList">
            <li className="navItem">
              <Link to="/" className="navLink">Inicio</Link>
            </li>
            <li className="navItem">
              <Link to="/galeria" className="navLink">Galeria</Link>
            </li>
            <li className="navItem">
              <Link to="/news" className="navLink">Noticias</Link>
            </li>
            <li className="navItem">
              <Link to="/aboutus" className="navLink">Sobre Nosotros</Link>
            </li>
            <li className="navItem">
              <Link to="/reglamentos" className="navLink">Documentos</Link>
            </li>
            <li className="navItem">
              <Link to="/historia" className="navLink">Nuestra Historia</Link>
            </li>
            <li className="navItem">
              <Link to="/equipo-directivo" className="navLink">Equipo Directivo</Link>
            </li>
            <li className="navItem">
              <a href="/contacto" className="cta-btn navLink" style={{marginLeft: '10px'}}>¡Contáctanos!</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Menú móvil */}
      <div className="mobile-menu">
        <div className="mobile-header">
          <div className="logo-container">
            <Link to="/">
              <img src={colegioIcon} alt="Logo Colegio" className="colegioIcon" />
            </Link>
            <div className="header-text">
              <h1 className="header-title">Colegio Cristiano</h1>
              <h1 className="header-title">Le Beau Jour</h1>
            </div>
          </div>
          <button className="menu-toggle" onClick={toggleMenu}>
            ☰
          </button>
        </div>
        {isOpen && (
          <div className="overlay" onClick={toggleMenu}>
            <div className="popup-menu" onClick={(e) => e.stopPropagation()}>
              <ul className="popup-navList">
                <li className="popup-navItem">
                  <Link to="/" className="popup-navLink" onClick={toggleMenu}>Inicio</Link>
                </li>
                <li className="popup-navItem">
                  <Link to="/galeria" className="popup-navLink" onClick={toggleMenu}>Galeria</Link>
                </li>
                <li className="popup-navItem">
                  <Link to="/news" className="popup-navLink" onClick={toggleMenu}>Noticias</Link>
                </li>
                <li className="popup-navItem">
                  <Link to="/aboutus" className="popup-navLink" onClick={toggleMenu}>Sobre Nosotros</Link>
                </li>
                <li className="popup-navItem">
                  <Link to="/reglamentos" className="popup-navLink" onClick={toggleMenu}>Documentos</Link>
                </li>
                <li className="popup-navItem">
                  <Link to="/historia" className="popup-navLink" onClick={toggleMenu}>Nuestra Historia</Link>
                </li>
                <li className="popup-navItem">
                  <Link to="/equipo-directivo" className="popup-navLink" onClick={toggleMenu}>Equipo Directivo</Link>
                </li>
                <li className="popup-navItem">
                  <a href="/contacto" className="cta-btn popup-navLink" onClick={toggleMenu}>¡Contáctanos!</a>
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
